import { render, staticRenderFns } from "./BillableAccRuleDetail.vue?vue&type=template&id=12357cde&scoped=true"
import script from "./BillableAccRuleDetail.vue?vue&type=script&lang=js"
export * from "./BillableAccRuleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12357cde",
  null
  
)

export default component.exports